import React from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded, withFirestore } from 'react-redux-firebase'
import { withRouter } from 'react-router'
import { compose, withProps } from 'recompose'

import {
  DEFAULT_CYCLE_TIMEOUT,
  DEFAULT_DISPLAY_MODE,
  DEFAULT_PLAYERS_PER_PAGE,
  DISPLAY_MODE_TV,
} from '../../constants/displayMode'
import { sortCategoriesByDefaultOrder } from '../../helpers/compare'
import { fsCollections } from '../../helpers/firestore'
import { categoriesByResultDisplayMode, ResultsDisplayMode } from '../../helpers/resultsDisplayMode'

import { parse } from '../../helpers/url'
import { TournamentCategory } from '../../schemas/Category'
import { Playground } from '../../schemas/Playground'
import { TenantId } from '../../schemas/Tenant'
import { TournamentId } from '../../schemas/Tournament'
import './ResultList.css'
import ResultsInCategory from './ResultsInCategory'

type ResultListOuterProps = {
  tenant: TenantId
  tournamentId: TournamentId
  resultsDisplayMode: ResultsDisplayMode
  playground: Playground
}

type ResultListInnerProps = ResultListOuterProps & {
  dataIsLoaded: boolean
  categories?: TournamentCategory[]
  tournamentName: any
  displayedCategories: TournamentCategory[]
  displayMode: 'tv' | 'pc'
  cycleTimeout: number
  playersPerPage: number
}

type ResultListState = {
  currentCategoryIndex: number
}

const calcNextCategoryIndex = (totalCategoriesCount: number, currentCategoryIndex: number) => {
  return currentCategoryIndex === totalCategoriesCount - 1 ? 0 : currentCategoryIndex + 1
}

class ResultList extends React.Component<ResultListInnerProps, ResultListState> {
  state = {
    currentCategoryIndex: 0,
  }

  cyclePages = () => {
    this.setState((state) => ({
      currentCategoryIndex: calcNextCategoryIndex(
        this.props.displayedCategories.length,
        state.currentCategoryIndex,
      ),
    }))
  }

  handleResultCycleComplete = () => {
    if (this.props.displayMode.toLowerCase() === DISPLAY_MODE_TV) {
      this.cyclePages()
    }
  }

  render() {
    const {
      displayMode,
      tenant,
      tournamentId,
      displayedCategories,
      playground,
      cycleTimeout,
      playersPerPage,
    } = this.props

    const categoriesForRender =
      displayMode === DISPLAY_MODE_TV && displayedCategories.length > 0
        ? [displayedCategories[this.state.currentCategoryIndex]]
        : displayedCategories

    return (
      <div className="ResultList">
        {categoriesForRender.map((category) => {
          return (
            <React.Fragment key={category.id}>
              <ResultsInCategory
                tenant={tenant}
                tournamentId={tournamentId}
                categoryId={category.id}
                playground={playground}
                onCycleComplete={this.handleResultCycleComplete}
                playersPerPage={playersPerPage}
                displayMode={displayMode}
                cycleTimeout={cycleTimeout}
              />
            </React.Fragment>
          )
        })}
      </div>
    )
  }
}

const mapStateToProps = ({ firestore }, { tenant, tournamentId, categoryId }) => ({
  categories: firestore.ordered[fsCollections.tournamentCategories(tenant, tournamentId)],
})

const createWatchArray = ({ tenant, tournamentId }) => [
  { collection: fsCollections.tournamentCategories(tenant, tournamentId) },
]

const addPropsFromQuery = ({
  location,
}): { playersPerPage: number; displayMode: string; cycleTimeout: number } => {
  const {
    playersPerPage = DEFAULT_PLAYERS_PER_PAGE,
    displayMode = DEFAULT_DISPLAY_MODE,
    cycleTimeout = DEFAULT_CYCLE_TIMEOUT,
  } = parse(location.search)

  // query param is a string
  const playersPerPageParsed = isNaN(Number(playersPerPage))
    ? DEFAULT_PLAYERS_PER_PAGE
    : Number(playersPerPage)

  return {
    playersPerPage: playersPerPageParsed,
    displayMode,
    cycleTimeout,
  }
}

export default compose<ResultListInnerProps, ResultListOuterProps>(
  withRouter,
  withFirestore,
  firestoreConnect(createWatchArray),
  connect(mapStateToProps),
  withProps(({ categories = [], resultsDisplayMode }) => ({
    dataIsLoaded: isLoaded(categories),
    displayedCategories: sortCategoriesByDefaultOrder(
      categoriesByResultDisplayMode(resultsDisplayMode, categories),
    ),
  })),
  withProps(addPropsFromQuery),
)(ResultList)



// WEBPACK FOOTER //
// ./src/components/tournament/ResultList.tsx